// Modo manutenção (somente leitura): lido da tabela app_maintenance (uma linha).
// O bloqueio de verdade é feito no banco (migração 0030); aqui só mostramos o aviso na tela.
import { supabase } from './supabase';

export interface MaintenanceState {
  enabled: boolean;
  message: string | null;
  allowUserIds: string[];
}

export async function loadMaintenance(): Promise<MaintenanceState | null> {
  const { data, error } = await supabase
    .from('app_maintenance')
    .select('enabled, message, allow_user_ids')
    .eq('id', 1)
    .maybeSingle();
  if (error || !data) return null; // tabela ainda não existe ou sem acesso: sem aviso
  const r = data as { enabled?: boolean; message?: string | null; allow_user_ids?: string[] | null };
  return {
    enabled: Boolean(r.enabled),
    message: r.message ?? null,
    allowUserIds: r.allow_user_ids ?? [],
  };
}
